"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSFER_OWNER = exports.UNPUBLISH_WIDGET = exports.GET_TEMPLATE_LIST = exports.GET_NODE_WIDGETS_PREVIOUS = exports.CREATE_WIDGET = exports.GET_NODE_WIDGETS = exports.RECENT_INSTALL_WIDGET = exports.COPY_WIDGET = exports.INSTALL_WIDGET = exports.WIDGET_CENTER_LIST = exports.INSTALLATION_WIDGETS = void 0;
// ================ Widget related =======================
exports.INSTALLATION_WIDGETS = '/widget/get';
exports.WIDGET_CENTER_LIST = '/widget/package/store/list';
exports.INSTALL_WIDGET = '/widget/create';
exports.COPY_WIDGET = '/widget/copy';
exports.RECENT_INSTALL_WIDGET = '/space/:spaceId/widget';
exports.GET_NODE_WIDGETS = '/node/:nodeId/widgetPack';
exports.CREATE_WIDGET = '/widget/package/create';
// Get the widget information installed by the node, which is only provided for preview, does not contain complete data
exports.GET_NODE_WIDGETS_PREVIOUS = '/node/:nodeId/widget';
// Get a list of widget templates
exports.GET_TEMPLATE_LIST = '/widget/template/package/list';
// remove widget
exports.UNPUBLISH_WIDGET = '/widget/package/unpublish';
// hand over widget
exports.TRANSFER_OWNER = '/widget/package/transfer/owner';
// ================ Widget related =======================
//# sourceMappingURL=url.widget.js.map